import { render, staticRenderFns } from "./no-authority.vue?vue&type=template&id=6e8260d7"
import script from "./no-authority.vue?vue&type=script&lang=js"
export * from "./no-authority.vue?vue&type=script&lang=js"
import style0 from "./no-authority.vue?vue&type=style&index=0&id=6e8260d7&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports